export type MediaType = '电影' | '电视剧' | '动漫' | '综艺' | '纪录片';

export interface MediaItem {
  id: string;
  title: string;
  enTitle: string;
  type: MediaType;
  genres: string[];
  region: string;
  year: number;
  rating: number;
  runtime: string;
  director: string;
  cast: string[];
  poster: string;
  backdrop: string;
  tagline: string;
  summary: string;
  story: string;
  episodes?: number;
  heat: number;
  tags: string[];
}

export const REGIONS = ['全部', '中国大陆', '中国香港', '中国台湾', '美国', '日本', '韩国', '英国', '法国', '泰国'];

export const YEARS = ['全部', '2026', '2025', '2024', '2023', '2022', '2021'];

export const SORT_OPTIONS = [
  { value: 'latest', label: '最新上映' },
  { value: 'rating', label: '评分最高' },
  { value: 'hot', label: '热门优先' },
];

export const CATEGORY_GENRES: Record<string, string[]> = {
  电影: ['全部', '动作', '喜剧', '剧情', '科幻', '悬疑', '爱情', '犯罪'],
  电视剧: ['全部', '都市', '古装', '悬疑', '年代', '家庭', '职场', '奇幻'],
  动漫: ['全部', '热血', '奇幻', '治愈', '科幻', '校园', '冒险'],
  综艺: ['全部', '真人秀', '访谈', '音乐', '竞技', '美食'],
  纪录片: ['全部', '人文', '自然', '美食', '历史', '科技'],
};

export const mediaList: MediaItem[] = [
  {
    id: 'm01',
    title: '长夜锈河',
    enTitle: 'Rusted River',
    type: '电影',
    genres: ['悬疑', '犯罪'],
    region: '中国大陆',
    year: 2026,
    rating: 8.9,
    runtime: '132 分钟',
    director: '沈砚舟',
    cast: ['雷钧', '叶楚宁', '许鹤鸣', '沈小满'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20noir%20movie%20poster%20of%20a%20lone%20detective%20standing%20on%20a%20rusty%20iron%20bridge%20at%20night%2C%20warm%20amber%20street%20lamps%20cutting%20through%20mist%2C%20muted%20dark%20green%20and%20deep%20charcoal%20tones%20with%20a%20single%20orange%20glow%2C%20rain%20texture%2C%20high%20contrast%20minimal%20composition%2C%20editorial%20film%20poster%20aesthetic&width=600&height=840&seq=boluomi-poster-m01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20rain-soaked%20industrial%20riverfront%20at%20dusk%2C%20rusty%20cranes%20silhouetted%20against%20a%20deep%20amber%20sky%2C%20reflective%20water%2C%20moody%20atmospheric%20fog%2C%20muted%20orange%20and%20dark%20green%20palette%2C%20filmic%20grain%2C%20dramatic%20lighting%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m01&orientation=landscape',
    tagline: '真相沉在河底，有人却想让它永远锈住。',
    summary: '一名退休刑警接到二十年前旧案的匿名线索，沿着锈迹斑斑的河道重新追查，发现整座城市的沉默都被人精心设计过。',
    story:
      '故事从一场持续四十天的暴雨开始。退休刑警陈守义在旧宅阁楼里发现一只被遗忘的档案袋，里面是一张泛黄的照片和一枚生锈的钥匙。照片上的女孩在二十年前失踪，案子最后以“自行离家”结案。他不肯相信这个结论，于是重新走访当年的证人：码头工人、出租车司机、已经改行做花店老板的法医。随着调查深入，他发现所有证人的说法都在同一年被统一过，而统一说法的会议记录来自一家早已注销的运输公司。长夜将尽时，陈守义站在锈河边，第一次看清了自己当年在案卷上签字时的犹豫。',
    heat: 96,
    tags: ['国产悬疑', '口碑佳作', '导演剪辑版'],
  },
  {
    id: 'm02',
    title: '海雾中的灯塔',
    enTitle: 'Lighthouse in the Fog',
    type: '电影',
    genres: ['剧情', '爱情'],
    region: '日本',
    year: 2025,
    rating: 8.6,
    runtime: '118 分钟',
    director: '森川遥',
    cast: ['绫濑真白', '佐伯凉太', '高桥千夏'],
    poster: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20film%20poster%20of%20a%20small%20white%20lighthouse%20on%20a%20rocky%20coast%20surrounded%20by%20soft%20morning%20sea%20fog%2C%20a%20young%20woman%20in%20a%20cream%20coat%20holding%20a%20lantern%2C%20gentle%20amber%20and%20sage%20green%20palette%2C%20quiet%20minimal%20composition%2C%20editorial%20film%20poster%20aesthetic&width=600&height=840&seq=boluomi-poster-m02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20seascape%20of%20a%20lighthouse%20in%20thick%20morning%20fog%2C%20soft%20golden%20sunrise%20behind%20misty%20layers%2C%20calm%20pale%20sea%2C%20muted%20amber%20and%20sage%20tones%2C%20peaceful%20minimal%20composition%2C%20filmic%20texture%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m02&orientation=landscape',
    tagline: '她把灯塔守了十年，只为等一封可能不会来的信。',
    summary: '海雾常年笼罩的小岛上，一位灯塔看守人与一位收音机修理工在冬天的二十天里交换了彼此的秘密。',
    story:
      '北方小岛一年有两百天被海雾覆盖。灯塔看守人浅井透子每天的工作只有三件事：擦镜子、点灯、记录天气。冬天，一个自称来修收音机的年轻人上了岛，说要在灯亮之前把岛上最后一台旧收音机修好。二十天里，他们交换了彼此的过去：透子为什么愿意一个人在岛上待十年，修理工又为什么把手上的旧伤疤一直藏着。雾散的那天，灯没有关，收音机里第一次传出了外面的声音。',
    heat: 82,
    tags: ['治愈', '文艺片', '海岛'],
  },
  {
    id: 'm03',
    title: '第七次日落',
    enTitle: 'The Seventh Sunset',
    type: '电影',
    genres: ['科幻', '剧情'],
    region: '美国',
    year: 2026,
    rating: 9.1,
    runtime: '146 分钟',
    director: '艾登·霍尔',
    cast: ['玛洛·陈', '尼尔·阿德勒', '伊莎贝拉·罗伊'],
    poster: 'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20poster%20featuring%20a%20scientific%20observatory%20dome%20on%20a%20desert%20planet%2C%20seven%20concentric%20sun%20rings%20in%20an%20orange%20sky%2C%20a%20lone%20figure%20in%20a%20white%20suit%20looking%20up%2C%20warm%20burnt%20orange%20and%20deep%20green%20palette%2C%20clean%20geometric%20composition%2C%20editorial%20poster%20design&width=600&height=840&seq=boluomi-poster-m03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20sci-fi%20landscape%20of%20a%20desert%20planet%20at%20sunset%20with%20seven%20overlapping%20sun%20discs%2C%20vast%20orange%20dunes%2C%20a%20small%20research%20dome%20silhouette%2C%20muted%20amber%20and%20olive%20green%20tones%2C%20epic%20minimal%20atmosphere%2C%20filmic%20texture%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m03&orientation=landscape',
    tagline: '每一次日落，都有人删掉一点记忆。',
    summary: '在只有七次日落的殖民星球上，气象学家发现每次日落之后，所有人的记忆都会被悄悄修正一次。',
    story:
      '第七日计划原本只是气象观测项目。殖民星球“阿玛拉”的公转周期极端，一年只有七次可见的日落。气象学家伊芙在第六次日落时发现，自己记录的观测日志与同事的记忆出现了系统性偏差：同一次风暴，被三个人记成了三个日期。她开始偷偷保存纸质记录，把数据写在只有自己能读懂的地方。第七次日落来临时，她必须在所有人遗忘之前，让整座基地看见真实的那一天。',
    heat: 99,
    tags: ['年度科幻', '硬科幻', 'IMAX 之作'],
  },
  {
    id: 'm04',
    title: '春风不渡',
    enTitle: 'Spring Never Crossed',
    type: '电视剧',
    genres: ['古装', '爱情'],
    region: '中国大陆',
    year: 2026,
    rating: 8.4,
    runtime: '全 40 集',
    director: '陆知微',
    cast: ['沈初一', '裴远舟', '柳听雪', '周既明'],
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20of%20an%20elegant%20woman%20in%20layered%20amber%20silk%20hanfu%20standing%20in%20a%20courtyard%20of%20fallen%20apricot%20blossoms%2C%20soft%20warm%20light%2C%20muted%20cream%20and%20orange%20palette%2C%20refined%20minimal%20composition%2C%20editorial%20poster%20aesthetic&width=600&height=840&seq=boluomi-poster-m04&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20view%20of%20an%20ancient%20Chinese%20courtyard%20in%20early%20spring%2C%20blossoming%20apricot%20trees%2C%20red%20lacquered%20pillars%2C%20misty%20mountains%20beyond%20the%20wall%2C%20warm%20creamy%20amber%20light%2C%20soft%20sage%20greens%2C%20elegant%20harmonious%20composition%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m04&orientation=landscape',
    tagline: '春风吹过关隘的时候，她已经在城门外站了三年。',
    summary: '一场被写进族谱的和亲，两个不肯认命的人。边关春风不渡，心事却先一步过了关。',
    story:
      '北境边城的守将之女顾春棠，被迫以和亲的名义前往敌国。她原以为这是一场一去不返的旅程，却在边关遇到负责护送她的年轻副将裴远舟。两人一路从互相试探到把命交给对方，终于在城门下做出第一次违抗命令的决定。此后的三年，她在敌国宫中替家国周旋，他在边关替她守着一座空城。',
    heat: 94,
    tags: ['古装大剧', '强强联合', '原著改编'],
  },
  {
    id: 'm05',
    title: '城市微光',
    enTitle: 'City Glimmer',
    type: '电视剧',
    genres: ['都市', '家庭'],
    region: '中国大陆',
    year: 2025,
    rating: 8.7,
    runtime: '全 32 集',
    director: '方柏川',
    cast: ['陶然', '林晚照', '陈抱朴', '米兰'],
    poster: 'https://readdy.ai/api/search-image?query=Warm%20urban%20drama%20poster%20of%20a%20young%20woman%20in%20a%20mustard%20coat%20standing%20on%20a%20city%20rooftop%20at%20dusk%2C%20soft%20window%20lights%20glowing%20in%20the%20background%2C%20muted%20amber%20and%20graphite%20tones%2C%20gentle%20minimal%20composition%2C%20editorial%20poster%20aesthetic&width=600&height=840&seq=boluomi-poster-m05&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20city%20rooftop%20view%20at%20blue-hour%20twilight%20with%20warm%20amber%20window%20lights%20across%20dense%20apartment%20blocks%2C%20soft%20haze%2C%20calm%20nostalgic%20mood%2C%20muted%20orange%20and%20dark%20green%20palette%2C%20cinematic%20texture%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m05&orientation=landscape',
    tagline: '这座城市的灯，总有一盏是为晚归的人留的。',
    summary: '一间开在老楼天台的深夜便利店，串起六个普通家庭在同一栋楼里的悲喜与和解。',
    story:
      '在老城区一栋即将拆迁的居民楼顶，有一间只在晚上十点后营业的便利店。店主陶然白天是会计，晚上就守在这方小小的灯下。来买泡面的加班族、偷偷给孙子买糖的老人、为了离婚话题吵到凌晨的夫妻，每一个人都在这间店停留过。三十二集里，楼道的声控灯坏了又修，楼下的公共电话亭被改成共享充电柜，六个家庭的邻里关系在拆与留之间慢慢变得柔软。',
    heat: 91,
    tags: ['现实题材', '烟火气', '群像'],
  },
  {
    id: 'm06',
    title: '铁线莲计划',
    enTitle: 'Project Clematis',
    type: '电影',
    genres: ['动作', '犯罪'],
    region: '中国香港',
    year: 2025,
    rating: 8.2,
    runtime: '124 分钟',
    director: '雷振邦',
    cast: ['高恩宇', '苏百川', '郑雨诗'],
    poster: 'https://readdy.ai/api/search-image?query=Action%20thriller%20movie%20poster%20of%20a%20man%20in%20a%20dark%20green%20jacket%20walking%20through%20a%20neon-lit%20night%20market%20alley%2C%20blurred%20amber%20lights%2C%20rain%20on%20the%20ground%2C%20gritty%20high-contrast%20composition%2C%20muted%20orange%20accents%2C%20editorial%20film%20poster&width=600&height=840&seq=boluomi-poster-m06&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20night%20market%20alley%20in%20heavy%20rain%2C%20glowing%20amber%20signs%20reflecting%20in%20puddles%2C%20deep%20green%20shadows%2C%20silhouetted%20figures%20at%20the%20far%20end%2C%20gritty%20thriller%20atmosphere%2C%20filmic%20texture%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m06&orientation=landscape',
    tagline: '一次押运，三个劫匪，整条街都在配合演出。',
    summary: '前特警队员接到一份看似普通的押运任务，中途才发现整座旧城区都被人提前布置成了陷阱。',
    story:
      '前特警队员高恩宇退役后在物流公司做押运。某天他接到一单奇怪的任务：把一只密封金属箱从旧城区送到港口，路线被精确规定，中途不允许停靠。车队出发不到十分钟，街角的监控全部失灵，红绿灯自己跳了红色，路边的小贩在同一秒离开了摊位。高恩宇意识到自己走在别人画好的地图里。他只有四十分钟和一把没有子弹的空枪，把箱子送往自己选择的地方。',
    heat: 88,
    tags: ['港式动作', '一镜到底', '高压节奏'],
  },
  {
    id: 'm07',
    title: '少年与鲸',
    enTitle: 'The Boy and the Whale',
    type: '动漫',
    genres: ['奇幻', '治愈'],
    region: '日本',
    year: 2025,
    rating: 9.0,
    runtime: '106 分钟',
    director: '宫岛悠',
    cast: ['日向佐和', '南云蓝', '小林美喞'],
    poster: 'https://readdy.ai/api/search-image?query=Anime%20film%20poster%20of%20a%20small%20boy%20standing%20on%20a%20wooden%20boat%20beside%20a%20gentle%20enormous%20whale%20under%20a%20warm%20sunset%20sky%2C%20hand-painted%20animation%20style%2C%20soft%20amber%20and%20teal%20green%20palette%2C%20dreamy%20minimal%20composition%2C%20editorial%20poster%20aesthetic&width=600&height=840&seq=boluomi-poster-m07&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20hand-painted%20anime%20seascape%20with%20a%20giant%20gentle%20whale%20gliding%20under%20a%20golden%20sunset%2C%20calm%20shallow%20water%2C%20soft%20floating%20clouds%2C%20warm%20amber%20and%20teal%2C%20dreamy%20atmosphere%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m07&orientation=landscape',
    tagline: '它每年只来一次，而他等了整个童年。',
    summary: '海边小镇的男孩与一头每年如约而至的鲸鱼成为朋友，在最后一个夏天学会了告别。',
    story:
      '海边的小镇上有一个传说：每隔一年，会有一头鲸鱼在夏至那天出现在港口。男孩阿海五岁时第一次见到它，从此每年夏天都带着自己做的木哨在防波堤等它。这套动画用最朴素的手绘风讲述成长：阿海从踮脚都看不到海平线的孩子，长成要离开小镇去外地读书的少年。最后一次见面时，鲸鱼没有鸣叫，只是慢慢转身游向深海。',
    heat: 90,
    tags: ['手绘动画', '暑期档', '合家欢'],
  },
  {
    id: 'm08',
    title: '长夜食堂·第三季',
    enTitle: 'Midnight Diner S3',
    type: '综艺',
    genres: ['美食', '访谈'],
    region: '中国大陆',
    year: 2026,
    rating: 8.5,
    runtime: '全 12 期',
    director: '总导演 阿苏',
    cast: ['常驻主持 老陶', '飞行嘉宾 若干'],
    poster: 'https://readdy.ai/api/search-image?query=Warm%20food%20variety%20show%20poster%20of%20a%20cozy%20small%20open%20kitchen%20at%20night%20with%20steaming%20noodles%2C%20hanging%20orange%20lamps%2C%20wooden%20counter%2C%20inviting%20amber%20glow%2C%20soft%20green%20plants%2C%20editorial%20poster%20composition&width=600&height=840&seq=boluomi-poster-m08&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cozy%20late-night%20street%20food%20stall%2C%20warm%20hanging%20lamps%2C%20steam%20rising%20from%20pots%2C%20rainy%20street%20reflections%2C%20muted%20amber%20and%20deep%20green%20palette%2C%20documentary%20still%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m08&orientation=landscape',
    tagline: '十二道家常菜，十二个深夜来客。',
    summary: '第三季把厨房搬到城市的天台，每期一位深夜来客，用一道菜换一个故事。',
    story:
      '《长夜食堂》第三季把棚内厨房换成城市天台。每期邀请一位观众投稿的普通人，带来一道与家人有关的菜，主持人老陶负责把这道菜复刻出来。第三季菜谱包括腌笃鲜、酒酿圆子、干炒牛河、红烧肉等十二道家常菜，每一道背后都有一个绕不开的家人故事。',
    heat: 78,
    tags: ['高口碑综艺', '深夜食堂', '美食'],
  },
  {
    id: 'm09',
    title: '流光之城',
    enTitle: 'Neon Province',
    type: '电视剧',
    genres: ['悬疑', '都市'],
    region: '韩国',
    year: 2026,
    rating: 8.3,
    runtime: '全 16 集',
    director: '延智勋',
    cast: ['河在勋', '尹素雅', '郑佑镇'],
    poster: 'https://readdy.ai/api/search-image?query=Mystery%20drama%20poster%20of%20a%20woman%20in%20a%20beige%20trench%20coat%20standing%20on%20a%20wet%20city%20street%20at%20night%2C%20geometric%20amber%20light%20patterns%20on%20the%20glass%2C%20dark%20green%20shadows%2C%20sharp%20modern%20composition%2C%20editorial%20poster&width=600&height=840&seq=boluomi-poster-m09&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20modern%20city%20street%20at%20night%20in%20soft%20rain%2C%20geometric%20warm%20light%20reflections%20on%20glass%20facades%2C%20empty%20crosswalk%2C%20deep%20green%20and%20amber%20palette%2C%20clinical%20cool%20mood%2C%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m09&orientation=landscape',
    tagline: '城市每天亮九百万盏灯，只有一盏在说谎。',
    summary: '一栋商业大楼的深夜保洁员发现每层楼的监控时间都慢了三分钟，而这个细节牵出了整座城市的秘密。',
    story:
      '深夜保洁员尹素雅在一栋写字楼工作，习惯每天从顶层一路擦到一层。某天她注意到，所有楼层的监控时钟都比标准时间慢三分钟。她把这件事记在手机备忘录里，没想到第二天就有人来问她是否看到了什么。16 集的故事沿着三分钟的时间差展开，从物业主任到楼里最大的租户，每个人都在维持着同一个小小的谎言。',
    heat: 85,
    tags: ['韩剧悬疑', '高能反转', '短剧集'],
  },
  {
    id: 'm10',
    title: '望山而居',
    enTitle: 'Living Toward the Mountain',
    type: '纪录片',
    genres: ['人文', '自然'],
    region: '中国大陆',
    year: 2025,
    rating: 9.2,
    runtime: '全 6 集',
    director: '纪录团队 山野工作室',
    cast: ['叙事旁白 林海'],
    poster: 'https://readdy.ai/api/search-image?query=Documentary%20poster%20of%20a%20traditional%20mountain%20village%20at%20sunrise%2C%20leaking%20wooden%20roof%20and%20terraced%20fields%2C%20soft%20morning%20mist%2C%20warm%20amber%20sun%20and%20deep%20forest%20green%2C%20quiet%20minimal%20composition%2C%20editorial%20poster%20aesthetic&width=600&height=840&seq=boluomi-poster-m10&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20documentary%20landscape%20of%20terraced%20mountain%20fields%20at%20dawn%20with%20layered%20mist%2C%20stone%20houses%20nestled%20in%20deep%20green%20forest%2C%20soft%20golden%20light%2C%20tranquil%20atmosphere%2C%20natural%20film%20texture%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m10&orientation=landscape',
    tagline: '山不会说话，但记录了所有人的一生。',
    summary: '六集人文纪录片，跟随六户人家在不同海拔的山中生活，记录一年四季的劳作与团圆。',
    story:
      '拍摄团队在海拔八百到两千四百米之间选了六户人家，每集讲一户，从春季播种讲到冬季腌菜。第六集拍到的是山顶的护林员一家：他们一年只下山两次，女儿在城里读大学，回家要坐五小时的车再走两小时山路。纪录片没有旁白式的煽情，只让人物自己说话，最终呈现的是一部关于“留下”与“离开”的温柔作品。',
    heat: 80,
    tags: ['高分纪录片', '人文中国', '治愈'],
  },
  {
    id: 'm11',
    title: '第二次告白',
    enTitle: 'Confession, Again',
    type: '电影',
    genres: ['爱情', '喜剧'],
    region: '中国大陆',
    year: 2024,
    rating: 7.9,
    runtime: '112 分钟',
    director: '柯一禾',
    cast: ['梁思远', '白若溪', '郑星野'],
    poster: 'https://readdy.ai/api/search-image?query=Romantic%20comedy%20poster%20of%20a%20young%20couple%20on%20a%20bright%20beach%20boardwalk%2C%20holding%20ice%20cream%2C%20soft%20pastel%20cream%20background%2C%20warm%20sunny%20light%2C%20playful%20minimal%20composition%2C%20editorial%20poster%20aesthetic&width=600&height=840&seq=boluomi-poster-m11&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20sunny%20seaside%20boardwalk%20on%20a%20clear%20summer%20day%2C%20pastel%20cream%20and%20warm%20orange%20palette%2C%20light%20breeze%20and%20soft%20shadows%2C%20airy%20romantic%20mood%2C%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m11&orientation=landscape',
    tagline: '有些话没说出口，是因为总想留到下一次。',
    summary: '一对分手七年的旧恋人，因为一场同学婚礼被迫同桌七天，把当年没说清楚的话重新讲了一遍。',
    story:
      '梁思远和白若溪分手七年，从没真正说过再见。一场大学同学的婚礼把他们安排在同一个海岛七天，还阴差阳错被指定为伴郎伴娘。从彩排到晚宴，两人被迫记住对方所有的习惯：她吃鱼不吃皮，他喝咖啡一定要两块冰。第七天，他们终于把当年那句卡在喉咙里的话讲了出来——只不过这次，没有人再逃跑。',
    heat: 74,
    tags: ['七夕档', '轻喜剧', '高糖'],
  },
  {
    id: 'm12',
    title: '荒原信号',
    enTitle: 'Signal in the Wasteland',
    type: '电影',
    genres: ['科幻', '悬疑'],
    region: '英国',
    year: 2025,
    rating: 8.4,
    runtime: '128 分钟',
    director: '艾略特·格雷',
    cast: ['艾伦·莫罗', '凯拉·福特', '朱利安·贝克'],
    poster: 'https://readdy.ai/api/search-image?query=Atmospheric%20sci-fi%20poster%20of%20a%20lone%20radio%20antenna%20in%20a%20vast%20empty%20moor%20at%20dusk%2C%20thick%20fog%2C%20single%20orange%20signal%20light%2C%20deep%20olive%20green%20palette%2C%20minimal%20restrained%20composition%2C%20editorial%20film%20poster&width=600&height=840&seq=boluomi-poster-m12&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20moody%20moorland%20at%20dusk%20with%20heavy%20fog%20and%20a%20lone%20radio%20antenna%20silhouette%2C%20deep%20olive%20green%20and%20muted%20amber%20light%2C%20vast%20empty%20space%2C%20atmospheric%20sci-fi%20still%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m12&orientation=landscape',
    tagline: '荒原上只有一个人，和一段重复了四十年的信号。',
    summary: '无线电研究员独自驻守荒原观测站，收听到一段来自四十年前、却提到了昨天的信号。',
    story:
      '英国北部的荒原观测站只有一个人值守，任务是每天记录一次频段扫描。研究员艾伦在值夜的第 43 天收到一段奇怪的窄带信号，编码里提到了他昨天刚换掉的水壶型号。信号记录的日期是四十年前。他开始把每一天的扫描结果打印出来，贴在墙上比对，最后发现信号并不是来自过去，而是一段被人为循环播放的告别。',
    heat: 83,
    tags: ['英伦科幻', '低预算高概念', '氛围感'],
  },
  {
    id: 'm13',
    title: '她是火焰',
    enTitle: 'She Is Fire',
    type: '电影',
    genres: ['剧情', '爱情'],
    region: '法国',
    year: 2024,
    rating: 8.1,
    runtime: '121 分钟',
    director: '克莱尔·杜邦',
    cast: ['艾米莉·洛朗', '马蒂斯·雷恩'],
    poster: 'https://readdy.ai/api/search-image?query=European%20art%20film%20poster%20portrait%20of%20a%20confident%20woman%20in%20a%20rust-orange%20coat%20under%20a%20warm%20spotlight%2C%20dark%20green%20background%2C%20grainy%20analog%20film%20texture%2C%20editorial%20poster%20composition&width=600&height=840&seq=boluomi-poster-m13&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20warm%20theatre%20stage%20bathed%20in%20amber%20light%2C%20empty%20velvet%20seats%2C%20dust%20in%20the%20light%20beam%2C%20deep%20green%20curtains%2C%20intimate%20analog%20film%20texture%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m13&orientation=landscape',
    tagline: '她烧掉剧本的那天，戏才真正开始。',
    summary: '一位剧院女演员在排练间隙突然拒绝再演别人写好的角色，转而把自己的生活搬上舞台。',
    story:
      '巴黎一家老剧院的演员艾米莉在排练一部经典爱情剧时，突然在第三次联排中途走下舞台。她说不出口的原因很简单：剧本里那个女人的每一句台词，都像是别人替她写好的。她开始每天带一台录音机回家，把自己的生活录下来，剪辑成新的剧本。首演的夜里，观众席上坐着那位她从未和解的母亲。',
    heat: 68,
    tags: ['影展入围', '女性题材', '舞台'],
  },
  {
    id: 'm14',
    title: '山海记·归墟',
    enTitle: 'Tales of Shanhai: Guixu',
    type: '动漫',
    genres: ['热血', '冒险'],
    region: '中国大陆',
    year: 2026,
    rating: 8.8,
    runtime: '全 24 集',
    director: '动画导演 白鹿',
    cast: ['配音 沈子卿', '配音 顾无咎', '配音 阿绫'],
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20series%20poster%20of%20a%20young%20swordsman%20standing%20on%20a%20floating%20island%20edge%20above%20a%20sea%20of%20clouds%2C%20amber%20sunset%20light%2C%20ink%20wash%20inspired%20styling%2C%20warm%20orange%20and%20deep%20jade%20palette%2C%20epic%20minimal%20poster%20composition&width=600&height=840&seq=boluomi-poster-m14&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20ink-wash%20inspired%20landscape%20of%20floating%20islands%20above%20a%20sea%20of%20clouds%20at%20sunset%2C%20amber%20light%20breaking%20through%2C%20deep%20jade%20green%20mountain%20silhouettes%2C%20vast%20mythic%20atmosphere%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m14&orientation=landscape',
    tagline: '山会走，海会干，只有记载者不能停笔。',
    summary: '据《山海经》残卷改编，少年记载者踏上寻找“归墟”的路，为即将消失的异兽留下最后的名字。',
    story:
      '在山海交界的地方，有一群以记录异兽为业的人，称作“记载者”。少年顾无咎继承了师父的残卷，卷上只剩十八种异兽的名字，并且每过一夜就模糊一个字。他必须在天亮之前找到归墟，把最后一个名字写进石壁。一路上他遇见了会说话的九尾、只剩一只眼睛的鲸，还有一位同样在找归墟的少女。',
    heat: 93,
    tags: ['国漫爆款', '神话改编', '周更'],
  },
  {
    id: 'm15',
    title: '老城甜汤',
    enTitle: 'Sweet Soup of the Old Town',
    type: '电视剧',
    genres: ['年代', '家庭'],
    region: '中国大陆',
    year: 2024,
    rating: 8.6,
    runtime: '全 36 集',
    director: '温砚',
    cast: ['曾丽华', '程一舟', '夏禾', '吴伯年'],
    poster: 'https://readdy.ai/api/search-image?query=Nostalgic%20family%20drama%20poster%20of%20a%20small%20sweet%20soup%20shop%20front%20in%20an%20old%20Chinese%20town%2C%20steaming%20bowls%2C%20warm%20hanging%20lanterns%2C%20amber%20and%20creamy%20cream%20palette%2C%20gentle%20composition%2C%20editorial%20poster&width=600&height=840&seq=boluomi-poster-m15&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20view%20of%20an%20old%20Chinese%20town%20alley%20at%20golden%20hour%2C%20stone%20slabs%2C%20small%20shop%20fronts%20with%20warm%20lamps%2C%20steam%20rising%2C%20muted%20amber%20and%20dusty%20green%20palette%2C%20nostalgic%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m15&orientation=landscape',
    tagline: '一碗甜汤，四十年光阴。',
    summary: '南方小城的一家甜汤铺，从八十年代开到今天，三代人的日子都熬在锅里。',
    story:
      '1984 年，曾丽华在镇上开了第一间甜汤铺，只卖三种汤：红豆沙、芝麻糊、番薯糖水。铺子沿着石板路搬了三次，锅换了两口，菜单多了二十几种。大儿子想出去做生意，小女儿想留在镇上守着店，孙子则想把甜汤做成短视频里的“老字号”。三十六集里，这个家庭所有重要的决定，都是在店打烊后、一张小木桌边完成的。',
    heat: 81,
    tags: ['年代剧', '美食人生', '温情'],
  },
  {
    id: 'm16',
    title: '极夜列车',
    enTitle: 'Night Train',
    type: '电影',
    genres: ['悬疑', '动作'],
    region: '日本',
    year: 2026,
    rating: 8.0,
    runtime: '115 分钟',
    director: '黑田悟',
    cast: ['渡边悠真', '石川遥', '木村彻'],
    poster: 'https://readdy.ai/api/search-image?query=Thriller%20poster%20of%20a%20snow-covered%20night%20train%20moving%20through%20a%20dark%20forest%2C%20warm%20amber%20windows%20cutting%20through%20cold%20blue-green%20snow%2C%20minimal%20high-contrast%20composition%2C%20editorial%20film%20poster&width=600&height=840&seq=boluomi-poster-m16&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20view%20of%20a%20night%20train%20crossing%20a%20snowy%20bridge%20in%20deep%20winter%2C%20warm%20orange%20window%20lights%2C%20dark%20pine%20forest%2C%20cold%20teal%20snow%20with%20amber%20highlights%2C%20tense%20atmospheric%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m16&orientation=landscape',
    tagline: '列车不会停，但有人必须在下车前找到答案。',
    summary: '开往极北的最后一班夜车，十二节车厢里坐着一名必须在天亮前被找到的证人。',
    story:
      '极北铁路一年只运营三个月。最后一班夜车开出站台十分钟后，车厢里的广播突然换成了陌生的声音：车上有一名证人，天亮前必须找到他，否则列车不会抵达终点。乘客们被分成了互相怀疑的小团体，而唯一愿意查清真相的是一名刚下夜班的列车检修员。他在十二节车厢之间来回穿行，慢慢意识到，下达指令的人可能就站在他身后。',
    heat: 79,
    tags: ['密室推理', '雪国氛围', '强节奏'],
  },
  {
    id: 'm17',
    title: '回家吃饭吧',
    enTitle: 'Come Home for Dinner',
    type: '综艺',
    genres: ['真人秀', '美食'],
    region: '中国大陆',
    year: 2025,
    rating: 8.2,
    runtime: '全 10 期',
    director: '总导演 郑小满',
    cast: ['常驻嘉宾 五人'],
    poster: 'https://readdy.ai/api/search-image?query=Cozy%20family%20dinner%20reality%20show%20poster%20with%20a%20warmly%20lit%20dining%20table%2C%20home-cooked%20dishes%2C%20wooden%20chairs%2C%20soft%20amber%20glow%2C%20green%20potted%20plants%2C%20friendly%20minimal%20composition%2C%20editorial%20poster&width=600&height=840&seq=boluomi-poster-m17&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20warm%20family%20kitchen%20at%20evening%20with%20cooking%20on%20the%20stove%2C%20soft%20amber%20light%2C%20wooden%20cabinets%2C%20green%20herbs%20on%20the%20counter%2C%20cozy%20documentary%20still%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m17&orientation=landscape',
    tagline: '十次回家，十顿迟到了很多年的饭。',
    summary: '五位常驻嘉宾各自回到成长的家乡，为家人做一顿饭，把没说完的话留在餐桌上。',
    story:
      '节目规则只有一个：嘉宾必须自己买菜、自己做、自己收拾，不能点外卖，也不能请人帮忙。十期节目拍了五个人的家乡，从东北的酸菜白肉到潮汕的牛肉火锅。最动人的一期是嘉宾在厨房里第一次学会母亲的手艺，才发现那道菜的秘诀是把火关小一点。',
    heat: 76,
    tags: ['慢综艺', '治愈', '家常菜'],
  },
  {
    id: 'm18',
    title: '玻璃温室',
    enTitle: 'Glasshouse',
    type: '电视剧',
    genres: ['职场', '悬疑'],
    region: '美国',
    year: 2025,
    rating: 8.5,
    runtime: '全 10 集',
    director: '诺拉·惠勒',
    cast: ['黛安娜·科恩', '卢卡斯·维恩', '苏菲·阿米尔'],
    poster: 'https://readdy.ai/api/search-image?query=Corporate%20thriller%20poster%20of%20a%20glass%20skyscraper%20reflecting%20warm%20sunset%2C%20single%20silhouette%20on%20a%20high%20floor%2C%20clean%20geometric%20composition%2C%20amber%20and%20deep%20green%20palette%2C%20editorial%20poster%20aesthetic&width=600&height=840&seq=boluomi-poster-m18&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20modern%20glass%20office%20tower%20facade%20at%20sunset%2C%20warm%20amber%20reflections%20in%20the%20windows%2C%20clean%20geometric%20grid%2C%20deep%20green%20shadows%2C%20minimal%20corporate%20atmosphere%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m18&orientation=landscape',
    tagline: '在温室里，所有的透明都是被设计的。',
    summary: '一家以“全透明办公”为口号的新能源公司，实习生发现透明的其实是所有人被监视的生活。',
    story:
      '新能源公司“温室”以全透明办公著称：没有独立办公室，所有会议记录公开，连洗手间的排队时间都可以在内部系统查到。新来的实习生黛安娜起初觉得这一切都很现代，直到她在内部系统里看到一份不该存在的名单，名单上的人名都对应着一个离职日期。十集里，她一边完成自己的实习项目，一边试图弄清这家公司到底在筛选什么样的人。',
    heat: 84,
    tags: ['美剧', '职场惊悚', '高智商'],
  },
  {
    id: 'm19',
    title: '夏至未至的海',
    enTitle: 'The Sea Before Solstice',
    type: '电视剧',
    genres: ['奇幻', '爱情'],
    region: '中国台湾',
    year: 2024,
    rating: 8.0,
    runtime: '全 14 集',
    director: '骆以安',
    cast: ['纪安', '沈念真', '游子昂'],
    poster: 'https://readdy.ai/api/search-image?query=Taiwanese%20romance%20drama%20poster%20of%20a%20young%20woman%20in%20a%20light%20linen%20dress%20standing%20in%20shallow%20sea%20water%20at%20sunset%2C%20warm%20peach%20and%20cream%20palette%2C%20soft%20dreamy%20composition%2C%20editorial%20poster%20aesthetic&width=600&height=840&seq=boluomi-poster-m19&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20sunset%20seascape%20with%20shallow%20warm%20water%20and%20long%20reflections%2C%20peach%20and%20cream%20sky%2C%20soft%20breeze%20texture%2C%20calm%20romantic%20atmosphere%2C%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m19&orientation=landscape',
    tagline: '每年夏至，海边多出一天，也只有一个人记得。',
    summary: '海边小镇的女孩发现每到夏至，时间会多出一天，而她在这天里总会遇见同一个陌生男孩。',
    story:
      '夏至那天，小镇的钟表会莫名其妙地慢上几小时。女孩沈念真从小就知道这个规矩，每年都会在这一天多出来的时间里去海边走走。十四集里，她在同一天不断遇见同一个男孩，对话却每次都不一样。直到有一天，男孩突然问她：你还记得上一次我们说了什么吗？',
    heat: 72,
    tags: ['台剧', '青春奇幻', '氛围美'],
  },
  {
    id: 'm20',
    title: '蜂鸟档案',
    enTitle: 'Hummingbird Files',
    type: '电影',
    genres: ['犯罪', '剧情'],
    region: '美国',
    year: 2023,
    rating: 8.7,
    runtime: '139 分钟',
    director: '马库斯·里德',
    cast: ['伊森·布莱克', '罗莎·维加', '托马斯·凯恩'],
    poster: 'https://readdy.ai/api/search-image?query=Crime%20drama%20poster%20of%20an%20archive%20room%20filled%20with%20filing%20boxes%20and%20a%20single%20desk%20lamp%2C%20one%20figure%20reading%20by%20warm%20amber%20light%2C%20deep%20green%20shadows%2C%20moody%20editorial%20poster%20composition&width=600&height=840&seq=boluomi-poster-m20&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20dim%20archive%20hall%20with%20rows%20of%20file%20cabinets%20and%20warm%20amber%20ceiling%20lamps%2C%20dust%20in%20the%20air%2C%20quiet%20tense%20atmosphere%2C%20muted%20orange%20and%20dark%20green%20palette%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m20&orientation=landscape',
    tagline: '档案不会说谎，整理档案的人会。',
    summary: '地方报社的档案管理员发现，二十年来所有被撤下的报道，都在同一套报纸里留下过痕迹。',
    story:
      '报社的档案管理员伊森每天的工作是把旧报纸录入系统。一次误操作中，他发现自己录入了同一日期、内容却完全不同的两版报纸。从那天起，他开始比对每一年的合订本，找出那些被悄悄替换过的版面。线索指向的不是某个人，而是一整套让真相消失的流程。',
    heat: 77,
    tags: ['奥斯卡提名', '新闻题材', '慢热佳作'],
  },
  {
    id: 'm21',
    title: '厨房里的哲学家',
    enTitle: 'Philosopher in the Kitchen',
    type: '纪录片',
    genres: ['美食', '人文'],
    region: '意大利',
    year: 2025,
    rating: 8.9,
    runtime: '全 5 集',
    director: '卢卡·费拉拉',
    cast: ['旁白 玛尔塔·罗西'],
    poster: 'https://readdy.ai/api/search-image?query=Documentary%20poster%20of%20an%20old%20Artisan%20pasta%20making%20hands%20on%20a%20floured%20wooden%20table%2C%20warm%20side%20light%2C%20cream%20and%20amber%20palette%2C%20minimal%20editorial%20composition%2C%20elegant%20restrained%20aesthetic&width=600&height=840&seq=boluomi-poster-m21&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20rustic%20Italian%20kitchen%20with%20warm%20sunlight%20through%20the%20window%2C%20fresh%20pasta%20on%20a%20wooden%20table%2C%20herbs%20and%20tomatoes%2C%20cream%20and%20amber%20palette%2C%20calm%20documentary%20still%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m21&orientation=landscape',
    tagline: '做饭这件事，本身就是一种思考方式。',
    summary: '五集纪录片走进意大利的五个家庭厨房，用一日三餐讲清他们如何看待时间、家族与生活。',
    story:
      '镜头在厨房里待了整整一年。第一集讲的是托斯卡纳的一对老夫妻，他们每天中午都会为彼此做一道面；最后一集讲的是米兰的一名年轻厨师，他在城市公寓里用微波炉复刻祖母的食谱。全片没有比赛、没有评分，只有切菜声、沸腾声和偶尔的沉默。',
    heat: 71,
    tags: ['美食纪录片', '意大利', '慢生活'],
  },
  {
    id: 'm22',
    title: '猎影者',
    enTitle: 'The Shadowhunter',
    type: '电视剧',
    genres: ['悬疑', '犯罪'],
    region: '中国大陆',
    year: 2025,
    rating: 8.1,
    runtime: '全 28 集',
    director: '商砚',
    cast: ['魏铭川', '余知夏', '段承阳'],
    poster: 'https://readdy.ai/api/search-image?query=Crime%20series%20poster%20of%20a%20detective%20in%20a%20charcoal%20coat%20standing%20under%20a%20streetlamp%20in%20rain%2C%20amber%20light%20pool%2C%20deep%20green%20night%20tones%2C%20gritty%20minimal%20composition%2C%20editorial%20poster&width=600&height=840&seq=boluomi-poster-m22&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20rainy%20city%20street%20at%20night%20with%20a%20single%20streetlamp%20casting%20warm%20amber%20light%20on%20wet%20asphalt%2C%20dark%20green%20shadows%2C%20gritty%20crime%20atmosphere%2C%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m22&orientation=landscape',
    tagline: '他追的不是凶手，是那个替凶手拍照的人。',
    summary: '刑侦队新来的图像分析师能从一个模糊的倒影里读出整条街的信息，她与老刑警组成了不太对付的一队。',
    story:
      '刑警魏铭川办案二十年，最相信的是现场和直觉。新调来的图像分析师余知夏却相信像素：她能从一张便利店监控的玻璃倒影里，推算出对面楼里灯的开关时间。两人搭档侦破的每一桩案子，都先从一张看似没用的照片开始。二十八集的主线是一条从第一集起就被拍下、却始终没有人认出的照片。',
    heat: 87,
    tags: ['刑侦剧', '单元+主线', '双主角'],
  },
  {
    id: 'm23',
    title: '孤岛放映',
    enTitle: 'Island Screening',
    type: '电影',
    genres: ['剧情', '喜剧'],
    region: '泰国',
    year: 2025,
    rating: 7.8,
    runtime: '104 分钟',
    director: '纳塔温·披猜',
    cast: ['普莱姆·颂昆', '妮达·瓦拉', '阿南·塔纳'],
    poster: 'https://readdy.ai/api/search-image?query=Warm%20indie%20film%20poster%20of%20an%20open-air%20movie%20screening%20on%20a%20small%20island%20at%20dusk%2C%20white%20bedsheet%20screen%2C%20children%20in%20silhouette%2C%20amber%20sunset%20glow%2C%20tropical%20greens%2C%20editorial%20poster%20aesthetic&width=600&height=840&seq=boluomi-poster-m23&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20open-air%20island%20screening%20at%20dusk%2C%20simple%20white%20screen%20between%20palm%20trees%2C%20warm%20amber%20sunset%2C%20tropical%20deep%20greens%2C%20relaxed%20nostalgic%20atmosphere%2C%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m23&orientation=landscape',
    tagline: '这座岛没有电影院，于是他们把整个岛变成了电影院。',
    summary: '海岛小镇唯一的放映员决定关掉开了三十年的露天影院，全镇人想尽办法留住最后一场放映。',
    story:
      '阿南在岛上放了三十年电影。放映机坏了，胶片库也快空了，他打算在年末关掉这间露天影院。镇长召集大家开会，渔民说可以拆船板做幕布，小学生说可以画海报，杂货店老板贡献了最后一盒爆米花。最后一场放映定在跨年夜，放的是一部谁都没听过名字的老片子，但它让整座岛在同一个晚上都没有回家。',
    heat: 66,
    tags: ['东南亚电影', '喜剧', '口碑小片'],
  },
  {
    id: 'm24',
    title: '白露未晞',
    enTitle: 'Dew Before Dawn',
    type: '电视剧',
    genres: ['年代', '家庭'],
    region: '中国大陆',
    year: 2023,
    rating: 8.8,
    runtime: '全 40 集',
    director: '沈砚舟',
    cast: ['顾长亭', '许清和', '白玉书', '林既白'],
    poster: 'https://readdy.ai/api/search-image?query=Period%20drama%20poster%20of%20a%20young%20woman%20in%20a%20muted%20amber%20cheongsam%20standing%20by%20a%20wooden%20window%2C%20early%20morning%20light%2C%20dust%20in%20the%20air%2C%20cream%20and%20olive%20green%20palette%2C%20refined%20editorial%20poster%20composition&width=600&height=840&seq=boluomi-poster-m24&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20period%20Chinese%20town%20street%20in%20early%20morning%20mist%2C%20wooden%20shopfronts%2C%20a%20few%20lanterns%20still%20burning%2C%20muted%20cream%20and%20olive%20green%20palette%2C%20nostalgic%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m24&orientation=landscape',
    tagline: '天还没亮的时候，总要有人先出门。',
    summary: '江南小镇的一个教师家庭，从民国的清晨走到新世纪的黄昏，四十年守着同一所小学。',
    story:
      '顾家的老宅在镇小学旁边，四代人里有三代半是老师。四十集的篇幅从 1936 年一直讲到 1976 年之后，讲的不是大历史，而是每天的早课、黑板上的粉笔字、学生的名字和雨天漏下来的屋檐水。剧中很多台词来自真实的日记，最后两集把镜头交给了正在操场上升旗的一群孩子。',
    heat: 86,
    tags: ['年代大剧', '豆瓣高分', '教育题材'],
  },
  {
    id: 'm25',
    title: '午夜面包房',
    enTitle: 'Midnight Bakery',
    type: '电影',
    genres: ['剧情', '爱情'],
    region: '日本',
    year: 2024,
    rating: 8.3,
    runtime: '109 分钟',
    director: '小林遥人',
    cast: ['西岛千代', '藤井悠', '中村早纪'],
    poster: 'https://readdy.ai/api/search-image?query=Bakery%20film%20poster%20of%20a%20small%20neighborhood%20bakery%20at%20midnight%20with%20warm%20glowing%20windows%20and%20fresh%20bread%20in%20the%20display%2C%20soft%20amber%20light%2C%20cream%20palette%2C%20quiet%20minimal%20composition%2C%20editorial%20poster&width=600&height=840&seq=boluomi-poster-m25&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20quiet%20Japanese%20street%20at%20midnight%20with%20a%20single%20bakery%20glowing%20warm%20amber%2C%20light%20snow%2C%20cozy%20intimate%20atmosphere%2C%20cream%20and%20deep%20green%20palette%2C%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m25&orientation=landscape',
    tagline: '凌晨两点，面包房只为一个人开灯。',
    summary: '一家只在凌晨营业的面包房，接待每一个睡不着的人，包括那位每天来买同一款面包的女生。',
    story:
      '面包师西岛千代把营业时间改到了凌晨两点到五点，理由是那时候的面团发酵得最好。其实她只是喜欢这座城市睡着之后的样子。每天都会有一个女孩来买同一款可颂，久了，两人开始有一搭没一搭地聊天。电影用一年的时间讲这件小事：关于失眠，也关于两个人在同一盏灯下慢慢熟起来的过程。',
    heat: 70,
    tags: ['日本电影', '深夜治愈', '小成本'],
  },
  {
    id: 'm26',
    title: '雷霆行动',
    enTitle: 'Thunder Operation',
    type: '电影',
    genres: ['动作', '剧情'],
    region: '中国大陆',
    year: 2025,
    rating: 7.7,
    runtime: '137 分钟',
    director: '郑炎',
    cast: ['廖震', '莫听山', '何予安'],
    poster: 'https://readdy.ai/api/search-image?query=Action%20film%20poster%20of%20rescue%20team%20members%20in%20orange%20uniforms%20standing%20in%20dust%20and%20smoke%2C%20dramatic%20backlight%2C%20heroic%20but%20restrained%20composition%2C%20deep%20green%20and%20amber%20palette%2C%20editorial%20poster&width=600&height=840&seq=boluomi-poster-m26&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20rescue%20scene%20of%20an%20industrial%20site%20at%20dusk%20with%20dust%20in%20the%20air%2C%20warm%20orange%20emergency%20lights%2C%20deep%20green%20industrial%20structures%2C%20heroic%20but%20realistic%20atmosphere%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m26&orientation=landscape',
    tagline: '六小时的黄金时间，一群不肯放弃的人。',
    summary: '一次山体滑坡后，救援队必须在六小时内进入塌方区，救出被困的七名工人。',
    story:
      '连续暴雨之后，山区公路发生大面积塌方，七名工人在隧道施工点被困。救援队队长廖震带着十五个人进入现场，面对的不仅是不断掉落的山石，还有一支早已超负荷运转的机械队伍。故事用大量实景拍摄再现救援流程，从雷达探测到掘进，每一分钟都在跟时间抢人。',
    heat: 75,
    tags: ['主旋律大片', '灾难救援', '实景拍摄'],
  },
  {
    id: 'm27',
    title: '星星便利店',
    enTitle: 'Star Convenience',
    type: '动漫',
    genres: ['治愈', '日常'],
    region: '中国大陆',
    year: 2025,
    rating: 8.4,
    runtime: '全 12 集',
    director: '动画导演 木棉',
    cast: ['配音 五月', '配音 老周', '配音 小北'],
    poster: 'https://readdy.ai/api/search-image?query=Slice-of-life%20anime%20poster%20of%20a%20tiny%20convenience%20store%20glowing%20warmly%20on%20a%20quiet%20street%20at%20night%2C%20soft%20amber%20light%2C%20a%20cat%20sitting%20by%20the%20door%2C%20gentle%20flat%20illustration%20style%2C%20cream%20and%20deep%20green%20palette%2C%20editorial%20poster&width=600&height=840&seq=boluomi-poster-m27&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20quiet%20residential%20street%20at%20night%20with%20a%20small%20convenience%20store%20glowing%20warm%20amber%2C%20soft%20rain%2C%20flat%20cozy%20illustration%20style%2C%20cream%20and%20deep%20green%20palette%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m27&orientation=landscape',
    tagline: '只要灯还亮着，就有人会来。',
    summary: '深夜便利店的三位店员和一只店猫，用十二个短故事记录街区里来来往往的人。',
    story:
      '这间开在居民区转角的便利店只有二十坪，却容纳了整个街区的夜生活。十二集里，每一集都围绕一个到店客人展开：投简历失败来买关东煮的毕业生、每天凌晨来买同一款牛奶的独居老人、决定在这里告白的年轻情侣。店员们从不多问，只是把热的东西递到他们手上。',
    heat: 73,
    tags: ['国产泡面番', '治愈系', '日常'],
  },
  {
    id: 'm28',
    title: '雪线之上',
    enTitle: 'Above the Snowline',
    type: '纪录片',
    genres: ['自然', '冒险'],
    region: '中国大陆',
    year: 2026,
    rating: 9.2,
    runtime: '全 4 集',
    director: '山野工作室',
    cast: ['摄影 团队'],
    poster: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20of%20a%20snowy%20mountain%20ridge%20at%20sunrise%2C%20golden%20light%20on%20the%20peaks%2C%20deep%20green%20valley%20below%2C%20vast%20minimal%20composition%2C%20editorial%20documentary%20aesthetic&width=600&height=840&seq=boluomi-poster-m28&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20snow-covered%20mountain%20range%20at%20golden%20sunrise%2C%20layers%20of%20peaks%20in%20pale%20mist%2C%20deep%20green%20forested%20valley%20below%20the%20snowline%2C%20warm%20amber%20light%2C%20epic%20natural%20documentary%20still%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m28&orientation=landscape',
    tagline: '雪线之上，四季只分成两个季节：能上去，和不能上去。',
    summary: '四集自然纪录片，用四季记录一条雪线两侧的生态与守护雪线的人。',
    story:
      '摄制组在海拔四千米驻守了一整年。第一集是春季融雪，第二集是夏季的花期，第三集拍到雪豹，第四集记录冬季最后的巡护队。全片几乎没有讲解，只有环境声和偶尔出现的巡护员对话。',
    heat: 69,
    tags: ['高分自然类', '四季全拍', '4K'],
  },
  {
    id: 'm29',
    title: '我们的乐队梦',
    enTitle: 'Our Band Dream',
    type: '综艺',
    genres: ['音乐', '竞技'],
    region: '中国大陆',
    year: 2026,
    rating: 8.0,
    runtime: '全 12 期',
    director: '总导演 何声',
    cast: ['导师 四人组', '乐队 二十组'],
    poster: 'https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%20of%20an%20empty%20stage%20with%20a%20single%20warm%20spotlight%20hitting%20an%20electric%20guitar%2C%20dark%20green%20background%2C%20amber%20glow%2C%20bold%20minimal%20editorial%20composition&width=600&height=840&seq=boluomi-poster-m29&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20concert%20stage%20bathed%20in%20warm%20amber%20light%20with%20silhouettes%20of%20a%20band%2C%20deep%20green%20haze%2C%20energetic%20live%20music%20atmosphere%2C%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m29&orientation=landscape',
    tagline: '没有舞台的人，也能唱到最亮的那束光里。',
    summary: '二十支来自小城市、校园和街头的乐队，用十二期时间争取一次真正的巡演机会。',
    story:
      '节目不设淘汰赛制的常规环节，而是每期给每支乐队一个命题：唱一首没见过的城市的歌、改编一首老歌、在早市里演一场。十二期之后，胜出的三支乐队会拿到真正的巡演合约。所有表演都采用现场收音，不做修音。',
    heat: 78,
    tags: ['乐队综艺', '现场收音', '原创音乐'],
  },
  {
    id: 'm30',
    title: '雾港往事',
    enTitle: 'Fog Harbor',
    type: '电视剧',
    genres: ['年代', '悬疑'],
    region: '中国香港',
    year: 2022,
    rating: 8.6,
    runtime: '全 30 集',
    director: '雷振邦',
    cast: ['苏百川', '郭锦华', '蔡咏之'],
    poster: 'https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20drama%20poster%20of%20a%20foggy%20harbor%20pier%20at%20dawn%20with%20small%20boats%2C%20warm%20amber%20lamps%2C%20muted%20teal%20green%20water%2C%20nostalgic%20film%20grain%2C%20editorial%20poster%20composition&width=600&height=840&seq=boluomi-poster-m30&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20foggy%20old%20harbor%20at%20dawn%20with%20wooden%20pier%2C%20small%20fishing%20boats%2C%20warm%20amber%20lamps%20in%20the%20fog%2C%20muted%20dark%20green%20water%2C%20nostalgic%20period%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=boluomi-wide-m30&orientation=landscape',
    tagline: '雾散了，港还在；人走了，话没说完。',
    summary: '八十年代的雾港码头，一家货运行的起落牵出三代人的恩怨与守望。',
    story:
      '1982 年，雾港的货运生意正红火。苏家经营的“百川货运”每天有三十条船靠岸，码头上的工人喊号子的声音能传到半山。三十年里，这个家族经历了繁荣、纷争与拆迁，唯一的见证者是那盏一直亮在码头尽头的灯。',
    heat: 67,
    tags: ['港剧经典', '年代群像', '口碑作'],
  },
];

export const getMediaById = (id: string): MediaItem | undefined => mediaList.find((item) => item.id === id);